//Order [0 - 500]
import * as OrderDeclineReasonTypes from "@/enum/OrderDeclineReasonType";
import * as ShipmentDeclineReasonTypes from "@/enum/ShipmentDeclineReasonType"
import _ from "underscore";

export const OrderCreated = 0
export const OrderCustomerApproved = 2
export const OrderExecutorApproved = 3
export const OrderExecutorDecline = 4
export const OrderCustomerEdited = 5
export const OrderExecutorEdited = 6
//Return order
export const ReturnOrderApproved = 7
export const ReturnOrderCancelApprove = 11

export const OrderStoppedByExecutor = 8
export const OrderResumedByExecutor = 9
export const OrderExecutorDeclineCancel = 10
//Shipment [500 - 1000]
export const ShipmentCreated = 500
export const ShipmentAccepted = 501
export const ShipmentEdited = 502
export const ShipmentDeclined = 503
export const ShipmentAcceptCanceled = 504
export const ShipmentDeleted = 505
export const ShipmentMatchAccepted = 506
export const ShipmentApproved = 507

//Invoice [1000 - ..]
export const InvoiceCreated = 1000
export const InvoiceCustomerApproved = 1001
export const InvoiceExecutorApproved = 1002
export const InvoiceDeleted = 1003

export const getActionText = action => {
    switch (action) {
        case OrderCreated:
            return "Заказ создан"
        case OrderCustomerApproved:
            return "Заказ подтверждён заказчиком"
        case OrderExecutorApproved:
            return "Заказ подтверждён поставщиком"
        case OrderExecutorDecline:
            return "Заказ отклонён поставщиком"
        case OrderCustomerEdited:
            return "Заказ изменён заказчиком"
        case OrderExecutorEdited:
            return "Заказ изменён поставщиком"
        case ReturnOrderApproved:
            return "Накладная на возврат подтверждена"
        case ReturnOrderCancelApprove:
            return "Отклонение накладной на возврат подтверждено"
        case OrderStoppedByExecutor:
            return "Заказ приостановлен поставщиком"
        case OrderResumedByExecutor:
            return "Заказ возобнолен поставщиком"
        case OrderExecutorDeclineCancel:
            return "Отклонение заявки исполнителем отменено"
        case ShipmentCreated:
            return "Поставка формирована"
        case ShipmentAccepted:
            return "Поставка принята"
        case ShipmentEdited:
            return "Поставка изменена"
        case ShipmentDeclined:
            return "Поставка отклонена"
        case ShipmentAcceptCanceled:
            return "Поставка отменена заказчиком"
        case ShipmentDeleted:
            return "Поставка удалена"
        case ShipmentMatchAccepted:
            return "Соответствие отгрузки принято"
        case ShipmentApproved:
            return "Поставка подтверждена"
        case InvoiceCreated:
            return "Счёт-фактура формирована"
        case InvoiceCustomerApproved:
            return "Счёт-фактура подтверждена заказчиком"
        case InvoiceExecutorApproved:
            return "Счёт-фактура подтверждена поставщиком"
        case InvoiceDeleted:
            return "Счёт-фактура удалена"
        default:
            return "Операция по умолчанию"
    }
}

export const reasonText = (action, reason) => {
    // window.console.log(action, reason)
    if (action === OrderExecutorDecline) {
        const keys = _.keys(OrderDeclineReasonTypes)
        let codeKey = _.find(keys, key => {
            return OrderDeclineReasonTypes[key].id === reason
        })

        return OrderDeclineReasonTypes[codeKey].name

    } else if (action === ShipmentDeclined) {
        const keys = _.keys(ShipmentDeclineReasonTypes)
        let codeKey = _.find(keys, key => {
            return ShipmentDeclineReasonTypes[key].id === reason
        })

        return ShipmentDeclineReasonTypes[codeKey].name
    }

    return ''
}